module.exports = __webpack_public_path__ + "img/logos_whatsapp-icon.8ac42f05.svg";